import { service } from '@ember/service';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class NetRevenueDashboardAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  buildURL(): string {
    const hotelId = this.hotelAndMarketService.hotel.id!;

    const url = new URL(
      `${this.host}/${APIGATEWAY}/reservations/hotel/${hotelId}/net-revenue`,
      this.host,
    );
    url.searchParams.set('subscription_id', hotelId);

    return url.toString();
  }
}
